/* Should match the content-container in
shells/ai-homepage/page-header.module.css */
.content-container {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    overflow: hidden;
    width: 100%;
    padding: 32px 64px;
}
